import * as React from 'react'
import Immutable from 'immutable'
import { Icon, Intent, EditableText, Button, Switch } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { splitDelimitedStringOrNull } from './inputOptionParser'

interface Props {
  onChange: (key, input) => void
  input: any
}

interface State {
  optionValue: string
}

export default class ConfigureOptions extends React.Component<Props, State> {
  addOptionInput: React.RefObject<HTMLInputElement>

  constructor(props) {
    super(props)
    this.state = { optionValue: '' }
    this.addOptionInput = React.createRef()
  }

  onAddDropdownOption = () => {
    const { optionValue } = this.state
    this.addDropDownOptions([optionValue])
    this.setState({ optionValue: '' }, () => {
      this.addOptionInput.current.focus()
    })
  }

  // Add an array of option name strings to the options props of the input
  addDropDownOptions = optionNames => {
    let newOptions = this.props.input.getIn(['props', 'options'])
    optionNames.forEach(optionValue => {
      if (!newOptions.find(option => option.get('key') === optionValue)) {
        newOptions = newOptions.push(Immutable.Map({ key: optionValue, value: optionValue }))
      }
    })

    this.props.onChange('options', newOptions)
  }

  onRemoveOption = idx => {
    this.props.onChange(
      'options',
      this.props.input.getIn(['props', 'options']).filter((_, i) => i !== idx)
    )
  }

  onPreserveOrderChange = () => {
    this.props.onChange('preserveOrder', !this.props.input.getIn(['props', 'preserveOrder']))
  }

  onInputChange = (idx, value) => {
    // TODO(@jackson) should just change this function to accept an entire input, not a key
    const newOptions = this.props.input.setIn(['props', 'options', idx], Immutable.Map({ key: value, value }))
    this.props.onChange('options', newOptions.getIn(['props', 'options']))
  }

  render() {
    const inputProps = this.props.input.get('props')
    return (
      <div style={{ background: 'white', padding: '10px' }}>
        <p>Add Options</p>
        <div>
          <Switch
            onChange={this.onPreserveOrderChange}
            label="Alphabetical order"
            checked={!inputProps.get('preserveOrder')}
          />
        </div>
        <div className="bp3-control-group">
          <div className="bp3-input-group bp3-fill">
            <Icon icon={IconNames.ADD_TO_ARTIFACT} />
            <input
              ref={this.addOptionInput}
              type="text"
              className="bp3-input"
              placeholder="Type or paste to add options"
              value={this.state.optionValue}
              onChange={e => this.setState({ optionValue: e.target.value })}
              onKeyUp={e => {
                if (e.keyCode === 13 && this.state.optionValue) {
                  this.onAddDropdownOption()
                }
              }}
              onPaste={e => {
                const pastedData = e.clipboardData.getData('text/plain')
                const optionNames = splitDelimitedStringOrNull(pastedData)
                if (optionNames) {
                  // If we have an array of options, use that to create new options
                  this.addDropDownOptions(optionNames)

                  e.preventDefault() // don't let the pasted data make it to the input field
                }
              }}
              autoFocus
            />
          </div>
          <Button intent={Intent.PRIMARY} onClick={this.onAddDropdownOption}>
            Add
          </Button>
        </div>

        <div>
          {inputProps.get('options').map((opt, i) => {
            return (
              <div key={i} /* eslint-disable-line */ style={{ display: 'flex', padding: '5px 0' }}>
                <EditableText
                  minWidth={200}
                  value={opt.get('key')}
                  onChange={v => this.onInputChange(i, v)}
                  selectAllOnFocus
                />
                <Icon
                  onClick={() => this.onRemoveOption(i)}
                  style={{ marginLeft: 'auto', cursor: 'pointer' }}
                  icon={IconNames.TRASH}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}
